<template>
    <div class="check-table" ref="checkTable">
        <div class="table-top">
            <span v-loading="loadingXls" class="table-top_btn" @click="exportTarget">导出数据</span>
        </div>
        <el-table
            v-if="tableHeight != 0 && !loading"
            :data="targetTable"
            :header-cell-style="{ background: '#f2f2f2', color: '#222' }"
            :height="tableHeight"
            border
            class="el-table"
            style="width: 100%;"
            >
            <el-table-column
                type="index"
                align="center"
                label="序号"
                width="50">
            </el-table-column>
            <el-table-column
                align="center"
                prop="date"
                min-width="120"
                label="时间"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <template v-if="leftIndex === 0">
                <el-table-column
                    v-for="item in checkIndicators"
                    :key="item.id"
                    align="center"
                    prop="targetList"
                    min-width="150"
                    :show-overflow-tooltip="true">
                    <template slot="header">
                        <span>{{item.targetNameCh}}</span>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ setName(scope.row.targetList, item.datasourceId) }}</span>
                    </template>
                </el-table-column>
            </template>
            <template v-if="leftIndex === 1">
                <el-table-column
                    v-for="item in tableData"
                    :key="item.id"
                    align="center"
                    prop="targetList"
                    min-width="150"
                    :show-overflow-tooltip="true">
                    <template slot="header">
                        <span>{{item.targetNameCh}}</span>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ setName(scope.row.targetList, item.datasourceId) }}</span>
                    </template>
                </el-table-column>
            </template>
        </el-table>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { exportXls } from "@/api/dataCenter"
import { streamFile } from "@/utils/load"

export default {
    props: {
        tableHeight: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loading: false,
            loadingXls: false
        }
    },
    computed: {
        ...mapGetters(["leftIndex", "targetTable", "tableData", "checkIndicators"]),
        // 设置名称
        setName() {
            return function (list, id) {
                let info = ""
                if (list && list.length > 0) {
                    const findItem = list.find( item => item.datasourceId === id)
                    info = findItem ? findItem.value : ""
                }
                return info
            }
        }
    },
    watch: {
        leftIndex: {
            handler(value) {
                this.initData()
            },
            deep: true
        },
        checkIndicators: {
            handler(value) {
                this.initData()
            },
            deep: true
        },
        tableData: {
            handler(value) {
                this.initData()
            },
            deep: true
        }
    },
    created() {
        this.initData()
    },
    methods: {
        ...mapActions(["GetTargetTable"]),
        // 初始数据
        initData() {
            const rLoading = this.openLoading();
            this.loading = true
            this.GetTargetTable()
                .then( () => {
                    this.loading = false
                    rLoading.close()
                })
        },
        // 导出指标 
        exportTarget() {
            let arr = []
            if (this.leftIndex === 0) {
                this.checkIndicators.forEach(item => {
                    arr.push(item.datasourceId)
                });
            } else if (this.leftIndex === 1) {
                this.tableData.forEach(item => {
                    arr.push(item.datasourceId)
                });
            }
            this.loadingXls = true
            exportXls({datasourceIds: arr.join(",")}).then(res => {
                this.loadingXls = false
                streamFile(res)
            }).catch(() => {
                this.loadingXls = false
            })
        }
    }
};
</script>

<style lang="less">
@import '../common.less';
</style>